import { jwtDecode } from "jwt-decode";
import { IEmployeeProfile } from 'src/Common/Interfaces/Profile/IEmployeeProfile';

// Helper function to decode the JWT and extract employee info
const decodeToken = (token: string): IEmployeeProfile => {
    try {
        const decoded :any = jwtDecode(token); // Decode the JWT token
        const employeeProfile: IEmployeeProfile = {
            UserId: decoded.userId,
            joiningDate:decoded.joiningDate,
            EmployeeCode: decoded.employeeId,
            Designation: decoded.designation,
            CNIC: decoded.cnic,
            PhoneNumber: decoded.phoneNumber,
            MobileNumber: decoded.mobileNumber,
            Grade: decoded.grade,
            ReportingToEmployee: decoded.reportingToEmployee,
            isActive: decoded.isActive === 'true', // Ensure boolean conversion
            FirstName: decoded.firstName,
            LastName: decoded.lastName, // You might need to check if `FamilyName` exists in the claims
            Email: decoded.email,

            branchID: decoded.branchId,
            branchName: decoded.branchName,
            branchLocation: decoded.branchLocation,
            branchCode: decoded.branchCode,

            companyId:decoded.companyId,
            companyName:decoded.companyName,

            // Company time zone claim ("Pakistan Standard Time (Asia/Karachi)") — used by
            // printDateTime.ts as a fallback when company settings carry no usable zone.
            timeZone: decoded.timeZone,

        };
        return employeeProfile;
    } catch (error) {
        console.error('Error decoding token:', error);
        throw new Error('Invalid token');
    }
};

export default decodeToken;